import React from 'react';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { LineChart, LineChartProps } from '@mui/x-charts';

interface CustomProps extends LineChartProps {
  id?: string;
  yLabel?: string;
  parentHeight?: boolean;
}

const CustomLineChart: React.FC<CustomProps> = ({
  id,
  title,
  yLabel,
  height = 400,
  parentHeight,
  ...props
}) => {
  const theme = useTheme();

  if (props.loading) {
    return (
      <Skeleton sx={{ width: '100%', height: parentHeight ? '100%' : height }} variant="rounded" />
    );
  }

  return (
    <Box id={id} position="relative" sx={{ height: '100%', width: '100%' }}>
      {title && (
        <Typography textAlign="center" variant="h3" sx={{ mb: -4 }}>
          {title}
        </Typography>
      )}
      <Stack direction="row" sx={{ height: '100%', width: '100%' }}>
        {yLabel != null && (
          <Typography
            sx={{
              writingMode: 'vertical-rl',
              transform: 'rotate(180deg)',
              textAlign: 'center',
            }}
          >
            {yLabel}
          </Typography>
        )}
        <LineChart
          {...props}
          colors={[theme.palette.primary.main]}
          height={parentHeight ? undefined : height}
          axisHighlight={props.axisHighlight ?? { x: 'none' }}
          tooltip={props.tooltip ?? { trigger: 'item' }}
        />
      </Stack>
    </Box>
  );
};

export default CustomLineChart;
